import * as tslib_1 from "tslib";
import { Vector3 } from "@babylonjs/core/Maths/math";
/**
 * Class used to transport Vector3 information for pointer events
 */

var Vector3WithInfo =
/** @class */
function (_super) {
  tslib_1.__extends(Vector3WithInfo, _super);
  /**
   * Creates a new Vector3WithInfo
   * @param source defines the vector3 data to transport
   * @param buttonIndex defines the current mouse button index
   */


  function Vector3WithInfo(source,
  /** defines the current mouse button index */
  buttonIndex) {
    if (buttonIndex === void 0) {
      buttonIndex = 0;
    }

    var _this = _super.call(this, source.x, source.y, source.z) || this;

    _this.buttonIndex = buttonIndex;
    return _this;
  }

  return Vector3WithInfo;
}(Vector3);

export { Vector3WithInfo };